export const useCustomError = (error) => {
  if (error.response && error.response.status === 404) {
    return createError({
      statusCode: 404,
      statusMessage: error.response.data.Message
    })
  }

  useNuxtApp().$sentry.captureException(error)

  return createError({
    statusCode: 500,
    statusMessage: (error.response && error.response.data && error.response.data.Message) || 'Error'
  })
}
